import React, { forwardRef } from "react";

export interface ContentInsetBoundaryProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Panel slots reserve the UI overhang; contained surfaces retain their own padding. */
  mode?: "panel" | "contained";
}

/** Owns a local inset context without allowing ancestor page rules to reach its children. */
export const ContentInsetBoundary = forwardRef<HTMLDivElement, ContentInsetBoundaryProps>(
  ({ mode = "panel", ...props }, ref) => (
    <div {...props} ref={ref} data-page-insets={mode} data-page-surface />
  ),
);
ContentInsetBoundary.displayName = "ContentInsetBoundary";
